import { NotificationPage } from './NotificationPage'
import { withNotificationPage } from './withNotificationPage'

const ConnectedNotificationPage = withNotificationPage(NotificationPage)

export { ConnectedNotificationPage as NotificationPage }
